import './jquery.selector.focusable';
import './scrollTrigger';
import { gsap } from 'gsap';
import { lockScroll, unlockScroll, horizontalResizeEvent } from './_utils';
import triggerAnalyticsEvent from '../analytics/analytics';
import throttle from 'lodash/throttle';

const className = 'Interstitial';
const classes = {
	navAtTop: 'Navigation--atTop',
};
const selectors = {
	component: `.${className}`,
	image: `.Interstitial-image`,
	container: `.Interstitial-container`,
	chevron: '.Interstitial-arrowButton',
	countdown: '.Interstitial-countdown',
	countdownNumber: '.countdown-number',
	navSkipToMain: 'nav .Navigation-skipToMainContent',
	navSmall: '.Navigation-sm',
	alertClose: '.Banner-closeButton',
	skipToMain: '.SkipToMainContent',
	triggerInterstitial: '.triggerInterstitial',
	logo: '.Interstitial-logo',
	logoContainer: '.Interstitial-logoContainer',
	textContainer: '.Interstitial-textContainer',
	heading: '.Interstitial-textContainer .Heading',
	ctaContainer: '.Interstitial-CtaContainer',
	backgroundContainer: '.Interstitial-backgroundContainer',
	video: '.Interstitial-video .Video-video',
	videoPlayBtn: '.Interstitial-video .Video-playButton',
};
let curtainMode = false;
let allowDisableCurtainMode = true;
let scrolling = false;
// left: 37, up: 38, right: 39, down: 40,
// spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36, tab: 9
const keys = { 38: 1, 40: -1, 32: -1, 33: 1, 34: -1, 35: -1, 36: 1 };
// modern Chrome requires { passive: false } when adding event
let supportsPassive = false;
try {
	window.addEventListener(
		'test',
		null,
		Object.defineProperty({}, 'passive', {
			get: function () {
				supportsPassive = true;
			},
		})
	);
} catch (e) {
	//empty by design
}

const wheelOpt = supportsPassive ? { passive: false, capture: true } : false;
const wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';
let ts;
window.addEventListener('touchstart', e => {
	ts = e.touches[0].clientY;
});

const getDirection = e => {
	let dir = keys[e.keyCode];
	if (e && e.changedTouches && e.changedTouches.length > 0) {
		dir = ts > e.changedTouches[0].clientY ? -1 : 1;
	} else if (dir === undefined || dir === null) {
		dir =
			e.wheelDelta ||
			-e.detail ||
			(e.originalEvent
				? e.originalEvent.wheelDelta ||
				  -e.originalEvent.detail ||
				  -(e.originalEvent.deltaY * 25)
				: e.wheelDelta);
	} else if (e.keyCode === 32) {
		//if focused on an element spacebar isn't for scrolling
		dir = document.activeElement.tagName.toLowerCase() !== 'body' ? undefined : dir;
	}
	return dir;
};
function addScrollEvent(eventHandler) {
	window.addEventListener('DOMMouseScroll', eventHandler, false); // older FF
	window.addEventListener(wheelEvent, eventHandler, wheelOpt); // modern desktop
	window.addEventListener('touchmove', eventHandler, wheelOpt); // mobile
	window.addEventListener('keydown', eventHandler, false);
	window.addEventListener('keyup', eventHandler, false);
}
export default function interstitial() {
	let interstitial = document.querySelector(selectors.component);
	if (interstitial) {
		//move the interstitial to the top of the body and wrap the existing body
		const heroImages = document.querySelectorAll('.Hero .lazypreload img');
		heroImages.forEach(heroImage => heroImage.setAttribute('loading', 'eager'));

		//fix popin issue on reopen. Doesn't work for pseudo elements.
		gsap.set(selectors.backgroundContainer, {
			y: 0,
		});
		gsap.set(selectors.container, {
			y: 0,
		});
		gsap.set(selectors.textContainer, {
			y: 0,
		});
		gsap.set(selectors.heading, {
			y: 0,
		});
		gsap.set(selectors.ctaContainer, {
			y: 0,
		});
		gsap.set(selectors.chevron, {
			y: 0,
		});
		gsap.set(selectors.logo, {
			y: 0,
		});

		const video = interstitial.querySelector(selectors.video);
		const videoPlayBtn = interstitial.querySelector(selectors.videoPlayBtn);
		//If theres a video on the default, need to move the play button so its clickable
		if (video && video.parentElement.classList.contains('Interstitial-video--default')) {
			interstitial.querySelector(selectors.container).appendChild(videoPlayBtn);
		}

		//setup storage id
		const storageId = `interstitial-${interstitial.id}`;

		let interval;

		const exitCurtainMode = instant => {
			clearInterval(interval);
			const hideAndReset = () => {
				window.requestAnimationFrame(() => {
					unlockScroll();
					if (curtainMode) {
						window.scroll(0, 0);
						$(document).trigger('leftCurtainMode');
					}
					disableCurtainMode();
				});
			};
			if (curtainMode && !scrolling && instant !== true) {
				scrolling = true;
				gsap.to(interstitial, {
					duration: 1,
					ease: 'none',
					onComplete: () => {
						scrolling = false;
						hideAndReset();
					},
					y: window.innerHeight * -1,
				});
			}
			if (instant === true) {
				hideAndReset();
			}
			$(selectors.countdown).hide();

			//pause the video when interstitial is closed
			if (video) {
				const theme = $(videoPlayBtn).data('theme');
				if (!video.paused) {
					video.pause();
					triggerAnalyticsEvent('video.pause', { element: video });
					$(video).toggleClass('Video--paused');
					$(videoPlayBtn)
						.toggleClass(`Button--playIcon--${theme}`)
						.toggleClass(`Button--pauseIcon--${theme}`);
				}
			}
		};
		const enterCurtainMode = instant => {
			if (!curtainMode && !scrolling) {
				lockScroll(true);
				activateCurtainMode();
				if (instant !== true) {
					gsap.set(interstitial, {
						y: window.innerHeight * -1,
					});
					allowDisableCurtainMode = false;
					scrolling = true;
					gsap.to(interstitial, {
						duration: 1,
						ease: 'none',
						onComplete: () => {
							scrolling = false;

							//play the video when interstitial is open
							if (video) {
								const theme = $(videoPlayBtn).data('theme');
								if (video.paused) {
									video.play().catch(() => {});
									triggerAnalyticsEvent('video.play', { element: video });
									$(video).toggleClass('Video--paused');
									$(videoPlayBtn)
										.toggleClass(`Button--playIcon--${theme}`)
										.toggleClass(`Button--pauseIcon--${theme}`);
								}
							}
							setTimeout(() => {
								allowDisableCurtainMode = true;
							}, 50);
						},
						y: 0,
					});
				} else {
					allowDisableCurtainMode = false;
					window.requestAnimationFrame(() => {
						gsap.set(interstitial, {
							y: 0,
						});
						setTimeout(() => {
							allowDisableCurtainMode = true;
						}, 50);
					});
				}
			}
		};
		const activateCurtainMode = () => {
			$(document).trigger('startingCurtainMode');
			gsap.set(interstitial, {
				zIndex: 50,
			});
			$(selectors.navSmall).addClass(classes.navAtTop);
			window.FS.GDPR.ifAllowed('functional', function () {
				localStorage.setItem(storageId, true);
			});
			curtainMode = true;
		};

		const disableCurtainMode = () => {
			gsap.set(interstitial, {
				y: window.innerHeight * -1,
			});
			curtainMode = false;
		};
		window.addEventListener(
			'resize',
			throttle(() => {
				if (!curtainMode) {
					disableCurtainMode();
				}
			}, 100)
		);

		interstitial.querySelector(selectors.chevron).onclick = exitCurtainMode;
		//don't watch for tab focusing if just focused window (selecting tab, maximizing, etc) or if we are in countdown mode
		let detectFocus = true;
		window.addEventListener('blur', () => (detectFocus = false));
		window.addEventListener('focus', () =>
			setTimeout(() => {
				detectFocus = true;
			}, 500)
		);
		const activate =
			location.search && new URLSearchParams(location.search).get('takeover') === 'true';
		if (activate || !localStorage.getItem(storageId)) {
			detectFocus = false;
			lockScroll(true);
			activateCurtainMode();
		} else {
			disableCurtainMode();
			exitCurtainMode(true);
			$(document).on('alertBannerAdded', () => {
				exitCurtainMode(true);
			});
			$(document).on('noAlertBanner', () => {
				exitCurtainMode(true);
			});
		}

		document.addEventListener('scroll', function (e) {
			if (allowDisableCurtainMode && window.scrollY > 0 && curtainMode) {
				exitCurtainMode();
			}
			if (curtainMode) {
				$(selectors.countdown).hide();
				detectFocus = true;
				clearInterval(interval);
			}
		});

		// make sure tabbing allows you to enter/leave
		$(document).on('focus', ':focusable', e => {
			if (detectFocus) {
				if (curtainMode && !interstitial.contains(e.target)) {
					disableCurtainMode();
					window.requestAnimationFrame(() => {
						exitCurtainMode(true);
					});
				}
			}
		});

		addScrollEvent(e => {
			const dir = getDirection(e);
			if (dir < 0 && !scrolling && curtainMode) {
				exitCurtainMode();
			}
		});

		// make sure tabbing allows you to enter/leave
		$(selectors.triggerInterstitial).on('click', enterCurtainMode);

		// countdown animation
		const countdownNumberEl = interstitial.querySelector(selectors.countdownNumber);
		let countdown = 7;
		countdownNumberEl.textContent = countdown;
		interval = setInterval(function () {
			countdown = --countdown;
			if (countdown <= 0) {
				detectFocus = true;
				exitCurtainMode();
			} else {
				countdownNumberEl.textContent = countdown;
			}
		}, 1000);

		const checkCurtainMode = () => {
			if (curtainMode) {
				enterCurtainMode(true);
			} else {
				window.requestAnimationFrame(() => {
					exitCurtainMode(true);
				});
			}
		};
		$(document).on(horizontalResizeEvent, checkCurtainMode);

		const otherInterstitials = Array.from(document.querySelectorAll(selectors.component));
		otherInterstitials.forEach(otherInterstitial => {
			if (interstitial.id !== otherInterstitial.id) {
				otherInterstitial.remove();
			}
		});
	}
}
